import moment from "moment";
import React, { Fragment, useState } from "react"
import 'react-image-lightbox/style.css';
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, Table, UncontrolledDropdown } from "reactstrap";
import iconSub from '../../../assets/images/icon-sub.png';
import profilePic from '../../../assets/images/users/no-img.jpg';
import NavTabNutri from "../../../components/NavTabNutri";
import RowEmpty from "../../../components/RowEmpty";
import PriceUtils from "../../../helpers/PriceUtils";
import { checkRole } from "../../../helpers/Roles";

const TABS = [
    {
        value:'import',
        label: "Nhập hàng"
    },
    {
        value:'return',
        label: "Trả hàng"
    },
    {
        value:'debt',
        label: "Công nợ"
    },
]

export const getDetailSource = (item:any)=>{
    
    if(item?.orders_id?.id){
        //Đơn hàng
        if(item?.orders_id?.type === 'online'){
            return{
                code: item?.orders_id?.code,
                type_name: Number(item?.total) <0 ? 'Hoàn hàng' : 'Đơn Online',
                link: `/orderonline/${item?.orders_id?.id}/view`
            }
        }
        return{
            code: item?.orders_id?.code,
            type_name: Number(item?.total) <0 ? 'Hoàn hàng' : 'Đơn POS',
            link: `/orderpos/${item?.orders_id?.id}/view`
        }
    } else if(item?.stock_import_id?.id){
        //Phiếu nhập hàng hàng
        return{
            code: item?.stock_import_id?.code,
            type_name: 'Phiếu nhập hàng',
            link: `/stockimport/${item?.stock_import_id?.id}/view`
        }
    }else if(item?.payment_id?.id){
        //Phiếu chi
        return{
            code: item?.payment_id?.code,
            type_name: 'Phiếu chi',
            // link: `/payment/${item?.payment_id?.id}/view`
            link: `/payment/list?payment_id=${item?.payment_id?.id}`
        }
    }else if(item?.receipts_id?.id){
        //Phiếu thu
        return{
            code: item?.receipts_id?.code,
            type_name: 'Phiếu thu',
            // link: `/receipts/${item?.receipts_id?.id}/view`
            link: `/receipts/list?receipts_id=${item?.receipts_id?.id}`
        }
    }else if(item?.designation_id?.id){
        //Phiếu chỉ định dịch vụ
        return{
            code: item?.designation_id?.code,
            type_name: 'Phiếu chỉ định dịch vụ',
            link: `/designation/${item?.designation_id?.id}/view`
        }
    }else if(item?.stock_return_id?.id){
        //Phiếu chỉ định dịch vụ
        return{
            code: item?.stock_return_id?.code,
            type_name: 'Phiếu trả hàng',
            link: `/stockreturn/${item?.stock_return_id?.id}/view`
        }
    }
}

const SupplierImport = (props: any) => {
    const { data } = props
    const router = useHistory()

    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th className="text-center" style={{ minWidth: 60}}>Mã phiếu</th>
                    <th className="text-center" style={{ minWidth: 60 }}>Cơ sở (Kho)</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Tổng tiền nhập</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Trạng thái</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Ngày nhập</th>
                </tr>
            </thead>
        )
    }
    
    const RenderBobyData = () => {
        if (!data || data?.length === 0) {
            return <RowEmpty column={5} title="Chưa có dữ liệu nhập hàng nào!" />;
        }
        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                    <RenderItem item={item} index={index} />
                ))}
            </tbody>
        )
    }

    const RenderItem = ({item, index}:any)=>{
        const gotoDetail = (item:any) => {
            router?.push(`/stockimport/${item?.id}/view`)
        }
        return (
            <tr key={`${item?.id}-${index}`} onClick={() => gotoDetail(item)}>
                <td><Link to={`/stockimport/${item?.id}/view`}>{item?.code}</Link></td>
                <td>{item?.branch_id?.name}</td>
                <td className="text-center">{PriceUtils.format(Number(item?.sub_total) , '') || '---'}</td>
                <td className="text-center">
                    {item?.status == 0 && <span className={'text-dark'}>Mới</span>}
                    {item?.status == 1 && <span className={'text-success'}>Xác nhận</span>}
                    {item?.status == 2 && <span className={'text-info'}>Nhập kho</span>}
                    {item?.status == -1 && <span className={'text-danger'}>Hủy</span>}
                </td>
                <td className="text-center">{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
            </tr>
        )
    }
    
    return (
        <Table className="mb-0 table-custom" responsive>
            <RenderHeadData />
            <RenderBobyData />
        </Table>
    )
}

const SupplierReturn = (props: any) => {
    const { data } = props

    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th className="text-center" style={{ minWidth: 60}}>Mã nhập</th>
                    <th className="text-center" style={{ minWidth: 60 }}>Mã trả</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Giá trị</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Trạng thái</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Ngày trả</th>
                </tr>
            </thead>
        )
    }
    
    const RenderBobyData = () => {
        if (!data || data?.length === 0) {
            return <RowEmpty column={5} title="Chưa có dữ liệu trả hàng nào!" />;
        }
        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                    <RenderItem item={item} index={index} />
                ))}
            </tbody>
        )
    }

    const RenderItem = ({item, index}:any)=>{
        return (
            <tr key={`${item?.id}-${index}`}>
                <td><Link to={'/'}>{item?.stock_import?.code}</Link></td>
                <td>{item?.code}</td>
                <td className="text-center">{item?.total ? PriceUtils.format(Number(item?.total || 0) , '') : '---'}</td>
                <td className="text-center">
                    ---
                </td>
                <td className="text-center">{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
            </tr>
        )
    }
    
    return (
        <Table className="mb-0 table-custom" responsive>
            <RenderHeadData />
            <RenderBobyData />
        </Table>
    )
}

const SupplierDebt = (props: any) => {
    const { data } = props
    const router = useHistory()

    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th className="text-left" style={{ minWidth: 60}}>Mã phiếu</th>
                    <th className="text-left" style={{ minWidth: 60 }}>Loại phiếu</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Ngày ghi công nợ</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Giá trị</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Nợ cần trả nhà cung cấp</th>
                </tr>
            </thead>
        )
    }
    
    const RenderBobyData = () => {
        if (!data || data?.length === 0) {
            return <RowEmpty column={5} title="Chưa có dữ liệu công nợ nào!" />;
        }
        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                    <RenderItem item={item} index={index} />
                ))}
            </tbody>
        )
    }

    const RenderItem = ({item, index}:any)=>{
        const source:any = getDetailSource(item)
        const gotoDetail = (item:any) => {
            router?.push(source?.link)
        }
        
        
        const total_debt = Number(item?.total_debt || 0)
        const total = Number(item?.total || 0)
        return (
            <tr key={`${item?.id}-${index}`} onClick={() => gotoDetail(item)}>
                <td><Link to={source?.link}>{source?.code}</Link></td>
                <td>{source?.type_name}</td>
                <td className="text-center">{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td className="text-center">{total ? PriceUtils.format(Number(total) , '') : '---'}</td>
                <td className="text-center">{total_debt ? PriceUtils.format(Number(total_debt) , '') : '---'}</td>
            </tr>
        )
    }
    
    return (
        <Table className="mb-0 table-custom" responsive>
            <RenderHeadData />
            <RenderBobyData />
        </Table>
    )
}

const SupplierTab = (props: any) => {
    const [tab, setTab] = useState('import');
    let tabList = TABS
    tabList = tabList?.reduce((prev:any, item:any)=>{
        if(
            (item?.value !== 'debt' && !checkRole(props?.user?.roles, ['debtSupplier'], props?.user?.role)) &&
            (item?.value !== 'import' && !checkRole(props?.user?.roles, ['viewListStockImport'], props?.user?.role)) &&
            (item?.value !== 'return' && !checkRole(props?.user?.roles, ['viewListStockReturn'], props?.user?.role))
        ){
            
        }else{
            prev = [...prev, item]
        }
        return prev
    },[])

    if(tabList?.length === 0) return null
    return (
        <div className="card">
            <div className="card-body">
                <Row>
                    <Col md={7}>
                        <NavTabNutri
                            {...props}
                            tabList={TABS}
                            setTab={(tab: string) => setTab(tab)}
                            tab={tab || 'stock'}
                            classes="mt-3 mb-0 nav-tab-full"
                        />
                    </Col>
                    <Col md={5}>
                    {tab === 'debt' && checkRole(props?.user?.roles, ['debtSupplier'], props?.user?.role) &&
                        <div className="text-right">
                            <UncontrolledDropdown className="align-self-center">
                                <DropdownToggle
                                    data-toggle="dropdown"
                                    tag="button"
                                    className="btn btn-link p-0 dropdown-toggle mr-0">
                                        <Button color="success" className="ml-2">
                                            <i className='uil uil-plus mr-1'></i> Tạo phiếu thu/chi
                                        </Button>
                                </DropdownToggle>
                                <DropdownMenu right className="topbar-dropdown-menu profile-dropdown-items">
                                    <div className="dropdown-item notify-item" onClick={() => props?.handleActionModal({type: 'addReceipts', data: {}})}>
                                        <span>Phiếu thu</span>
                                    </div>
                                    <DropdownItem divider />
                                    <div className="dropdown-item notify-item" onClick={() => props?.handleActionModal({type: 'addPayment', data: {}})}>
                                        <span>Phiếu chi</span>
                                    </div>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    }
                    </Col>
                </Row>
                
                <div className="mt-4">
                    {tab === 'import' && checkRole(props?.user?.roles, ['viewListStockImport'], props?.user?.role) && <SupplierImport {...props} data={props?.stock_imports}/>}
                    {tab === 'return' && checkRole(props?.user?.roles, ['viewListStockReturn'], props?.user?.role) && <SupplierReturn {...props} data={props?.stock_return}/>}
                    {tab === 'debt' && checkRole(props?.user?.roles, ['debtSupplier'], props?.user?.role) && <SupplierDebt {...props} data={props?.supplier_debts}/>}
                </div>
            </div>
        </div>
    )
}

export default SupplierTab